import styled from 'styled-components';
import { Text } from '@make-software/tg-mini-app-ui';

export const ProjectLogoContainer = styled.div<{ width?: number; height?: number }>(
  ({ theme, width = 80, height = 80 }) =>
    theme.withMedia({
      display: 'flex',
      width: `${width}px`,
      height: `${height}px`,
      aspectRatio: 1 / 1,
      borderRadius: 4,
      backgroundColor: '#505161',
      alignItems: 'center',
      justifyContent: 'center'
    })
);

export const ProjectLogo = styled.img<{ size?: number }>(({ theme, size = 80 }) =>
  theme.withMedia({
    width: `${size}%`,
    height: `${size}%`,
    objectFit: 'cover'
  })
);

export const ProjectIndex = styled.div`
  display: flex;
  height: 17px;
  padding: 0 4px;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  border-radius: 4px;
  background: #593d44;
  text-align: center;
`;

export const ProjectIndexText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '11px',
    color: '#FB6F6A',
    fontFamily: 'Inter'
  })
);

export const ProjectTitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '16px',
    fontFamily: 'Inter'
  })
);

export const ProjectDescription = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '12px',
    color: '#A9AAAD',
    lineHeight: '140%',
    whiteSpace: 'pre-line',
    fontFamily: 'Inter'
  })
);
